import React from 'react';
import S from '../../UmbracoForm.styles';
const Textarea = React.forwardRef(({ field, dirty, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error },
        React.createElement(S.Label, { htmlFor: field.alias },
            field.caption,
            React.createElement(S.MandatoryIndicator, null, otherProps.indicator)),
        React.createElement(S.Textarea, { ref: ref, id: field.alias, placeholder: field.placeholder, required: field.required, ...otherProps }),
        React.createElement(S.Line, null),
        error && React.createElement(S.Error, null, error.message)));
});
Textarea.displayName = 'Textarea';
export default Textarea;
